<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <component-header
      title="Edit Subscription"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push({ name: 'Subscription Plan' })"
    />
    <div v-if="!loading">
      <b-row>
        <b-col md="12">
          <b-card>
            <ValidationObserver>
              <form class="mt-3">
                <v-card
                  border-variant="info"
                  header-bg-variant="primary"
                  header-text-variant="white"
                  class="full-width"
                >
                  <div class="m-2 p-3">
                    <h2 style="color: var(--primary)">General</h2>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="planName">Name </label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="planName"
                          >
                            <b-form-input
                              class=""
                              style="width: 75%"
                              id="planName"
                              inputType="text"
                              v-model="inputObject.planName"
                            />
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="scopeOptions">Scope </label>
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Scope"
                    > -->
                          <eb-select
                            style="background-color: #fff; width: 75%"
                            id="scopeOptions"
                            type="text"
                            label="label"
                            v-model="inputObject.scope"
                            :options="scopeOptions"
                            :selected="inputObject.scope"
                            placeholder="Select Scope type"
                            disabled
                          ></eb-select>
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col md="4">
                        <b-row class="mt-4 ml-2">
                          <label for="status">Status :</label>
                          <c-switch
                            class="mx-1"
                            color="success"
                            v-model="inputObject.isActive"
                            label="label"
                            id="status"
                            variant="pill"
                            data-on="yes"
                            data-off="no"
                          />
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="8">
                        <div class="form-group">
                          <label for="description">Description </label>

                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="description"
                          >
                            <textarea
                              rows="6"
                              cols="50"
                              id="description"
                              inputType="text"
                              class="form-control"
                              maxlength="1500"
                              v-model="inputObject.description"
                            />
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="orgAccessLevel">org Access Level </label>
                          <eb-select
                            type="text"
                            v-model="inputObject.orgAccessLevel"
                            :selected="inputObject.orgAccessLevel"
                            :options="orgAccessOptions"
                            style="width: 75%"
                            label="label"
                            id="orgAccessLevel"
                            placeholder="Select org Access Level"
                            disabled
                          ></eb-select>
                        </div>
                        <div
                          v-if="
                            inputObject.orgAccessLevel &&
                            inputObject.orgAccessLevel.value === 'LIMITED'
                          "
                        >
                          <label for="orgAccessLevel">org Access List </label>
                          <multiselect
                            v-model="inputObject.orgAccessList"
                            tag-placeholder="Add this as new org Access"
                            placeholder="Select org Access List"
                            label="name"
                            style="width: 75%"
                            track-by="keys"
                            :options="orgAccessListOptions"
                            :multiple="true"
                            :taggable="false"
                            :open-direction="'bottom'"
                            disabled
                          ></multiselect>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </v-card>
                <v-card>
                  <div class="m-2 p-3">
                    <h2 style="color: var(--primary)">Pricing</h2>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="paymentType">Payment Type </label>
                          <eb-select
                            id="paymentType"
                            style="background-color: #fff"
                            type="text"
                            label="label"
                            v-model="inputObject.paymentType"
                            :selected="inputObject.paymentType"
                            :options="paymentType"
                            placeholder="Select payment type"
                            disabled
                          ></eb-select>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="taxCode">Tax Code </label>
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="taxCode"
                    > -->
                          <eb-select
                            id="taxCode"
                            style="background-color: #fff"
                            type="text"
                            label="label"
                            v-model="inputObject.taxCode"
                            :selected="inputObject.taxCode"
                            :options="taxcodeoptions"
                            placeholder="Select tax code"
                            disabled
                          ></eb-select>
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="chargeCode">Charge Code </label>
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="chargeCode"
                    > -->
                          <b-form-input
                            id="chargeCode"
                            inputType="text"
                            maxlength="100"
                            v-model="inputObject.chargeCode"
                            readonly
                          />
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="currency">Currency </label>
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="currency"
                    > -->
                          <b-form-input
                            id="currency"
                            inputType="Number"
                            maxlength="100"
                            v-model="inputObject.currency"
                            readonly
                          />
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="price"
                    > -->
                          <label for="price">Price </label>
                          <b-form-input
                            id="price"
                            type="number"
                            maxlength="100"
                            v-model="inputObject.price"
                            readonly
                          />
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col
                        v-if="inputObject.cadencetype.value === 'EVENT'"
                        md="4"
                      >
                        <div class="form-group">
                          <label for="eventType">Event </label>
                          <eb-select
                            id="eventType"
                            style="background-color: #fff"
                            type="text"
                            label="label"
                            v-model="inputObject.eventType"
                            :options="eventType"
                            placeholder="Select Event type"
                            :selected="inputObject.eventType"
                            disabled
                          ></eb-select>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="uom">Unit Of Measurement </label>
                          <eb-select
                            id="uom"
                            style="background-color: #fff"
                            type="text"
                            label="label"
                            v-model="inputObject.uom"
                            :selected="inputObject.uom"
                            :options="unitOfMeasurementtype"
                            placeholder="Select payment type"
                            disabled
                          ></eb-select>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="baseQuantity"> Base Quantity </label>
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="baseQuantity"
                    > -->
                          <b-form-input
                            id="baseQuantity"
                            inputType="Number"
                            maxlength="100"
                            v-model="inputObject.baseQuantity"
                            readonly
                          />
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="price"
                    > -->
                          <label for="cadence">Cadence Type </label>
                          <eb-select
                            id="cadence"
                            style="background-color: #fff"
                            label="label"
                            v-model="inputObject.cadencetype"
                            :selected="inputObject.cadencetype"
                            :options="cadencetype"
                            placeholder="Select Cadence type"
                            disabled
                          ></eb-select>
                          <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                        </div>
                      </b-col>
                      <b-col md="4">
                        <b-row class="mt-4 ml-2">
                          <label for="autoRenewal">Auto Renewal :</label>
                          <c-switch
                            class="mx-1"
                            color="success"
                            v-model="inputObject.autoRenewal"
                            label="label"
                            id="autoRenewal"
                            variant="pill"
                            data-on="yes"
                            data-off="no"
                          />
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </v-card>
                <v-card>
                  <div class="m-2 p-3">
                    <h2 style="color: var(--primary)">Provisioning</h2>
                    <b-row>
                      <!-- <b-col md="4">
                      <label for="planAccess">Plan Access </label>
                      <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="planAccess"
                    > -->
                      <!-- <eb-select
                        style="background-color: #fff;width:75%;"
                        id="scopeOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.planAccess"
                        :options="accessrulesList"
                        :selected="inputObject.planAccess"
                        placeholder="Select Scope type"
                        disabled
                      ></eb-select> -->
                      <!-- <b-input
                      style="width: 75%;"
                      id="rewardValue"
                      type="text"
                      v-model="inputObject.planAccess"
                    ></b-input> -->
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                    </b-col> -->
                      <b-col md="4">
  <div class="form-group">
    <label for="plantype">Plan Type </label>
    <!-- <ValidationProvider
      rules="required"
      v-slot="{ errors }"
      name="plantype"
    > -->
    <eb-select
      style="background-color: #fff"
      id="plantype"
      type="text"
      label="label"
      v-model="inputObject.planType"
      :selected="inputObject.planType"
      :options="planType"
      placeholder="Select plan type"
      disabled
    ></eb-select>
    <!-- <span class="validate-error">{{ errors[0] }}</span>
    </ValidationProvider> -->
  </div>
</b-col>

<b-col md="4">
  <div class="form-group">
    <label for="validity">Validity </label>
    <!-- <ValidationProvider
      rules="required"
      v-slot="{ errors }"
      name="validity"
    > -->
    <b-form-input
      id="validity"
      inputType="Number"
      maxlength="100"
      v-model="inputObject.validity"
      readonly
    />
    <!-- <span class="validate-error">{{ errors[0] }}</span>
    </ValidationProvider> -->
  </div>
</b-col>
</b-row>

<b-row>
  <b-col md="4">
    <div class="form-group">
      <label for="planlimit">Plan Limit </label>
      <!-- <ValidationProvider
        rules="required"
        v-slot="{ errors }"
        name="planlimit"
      > -->
      <b-form-input
        id="planlimit"
        inputType="text"
        maxlength="100"
        v-model="inputObject.planlimit"
        readonly
      />
      <!-- <span class="validate-error">{{ errors[0] }}</span>
      </ValidationProvider> -->
    </div>
  </b-col>

  <!-- ✅ Features now shifted to same column (md=4) like Validity -->
  <b-col md="4">
    <label for="planFeatures">Features </label>
    <div
      class="mb-2 d-flex align-items-center"
      v-for="(e, idx) in inputObject.planFeatures"
      :key="idx"
    >
      <ValidationProvider
        rules="required"
        v-slot="{ errors }"
        name="planFeatures"
      >
        <b-form-input
          id="planFeatures"
          class="mr-2"
          inputType="text"
          style="width: 100%;"
          maxlength="100"
          v-model="e.planFeatures"
        />
        <span class="validate-error">{{ errors[0] }}</span>
      </ValidationProvider>

      <b-button
        btn-special="primary"
         size="md"
         :style="{
          background: e.isRemovable ? 'var(--danger)' : '#4dbd74',
          border: e.isRemovable ? '1px solid var(--danger)' : '1px solid #4dbd74',
          
        }"  @click="onClickEamilButton(e, idx)"
      >
        <i v-if="!e.isRemovable" class="fa fa-plus-circle mr-1"></i>
        <i v-if="e.isRemovable" class="fa fa-minus-circle mr-1"></i>
        {{ e.isRemovable ? 'Remove' : 'Add' }}
      </b-button>
    </div>
  </b-col>

  <b-col md="4">
    <b-row class="mt-4 ml-2">
      <!-- <label for="isActive">isActive :</label>
      <c-switch
        class="mx-1"
        color="success"
        v-model="isActive"
        label="label"
        id="isActive"
        variant="pill"
        data-on="yes"
        data-off="no"
      /> -->
    </b-row>
  </b-col>

                    </b-row>
                  </div>
                </v-card>
              </form>
            </ValidationObserver>
          </b-card>
          <div class="text-center mb-4">
            <button
              type="button"
              class="btn btn-primary mr-4"
              classic="mr-1 btn-primary"
              text="Update"
              @click.prevent="handleSubmit"
            >
              Update
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subscriptionplanDetails from "@/components/MasterSetup/subscriptionplan/SubscriptionplanDetails";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "EditSubscription",
  components: {
    ebButton,
    cSwitch,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    subscriptionplanDetails,
    loader,
    ComponentHeader,
  },
  // props: {
  //   details: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  data: () => {
    return {
      details: {},
      show: true,
      loading: false,
      currentProvider: "",
      status: true,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        autoRenewal: true,
        cadencetype: "",
        scope: "",
        orgAccessLevel: "",
        orgAccessList: "",
        planName: "",
        taxCode: "",
        chargeCode: "",
        description: "",
        planType: "",
        isActive: true,
        planlimit: "",
        validity: "",
        planAccess: "",
        paymentType: "",
        cadencetype: "",
        eventType: "",
        price: "",
        currency: "",
        baseQuantity: "",
        uom: "",
        planFeatures: [
          {
            planFeatures: "",
            isRemovable: false,
            text: "Add",
          },
        ],
      },
      paymentType: [
        {
          label: "Prepaid",
          value: "PRE-PAID",
        },
        {
          label: "Postpaid",
          value: "POST-PAID",
        },
      ],
      orgAccessOptions: [
        {
          label: "GLOBAL",
          value: "GLOBAL",
        },
        {
          label: "LIMITED",
          value: "LIMITED",
        },
      ],
      cadencetype: [
        {
          label: "Monthly",
          value: "MONTHLY",
        },
        {
          label: "Quarterly",
          value: "QUARTERLY",
        },
        {
          label: "One time",
          value: "ONE-TIME",
        },
        {
          label: "Event",
          value: "EVENT",
        },
      ],
      scopeOptions: [
        {
          label: "PARTNER",
          value: "PARTNER",
        },
        {
          label: "CUSTOMER",
          value: "CUSTOMER",
        },
      ],
      planType: [
        {
          label: "DURATION",
          value: "DURATION",
        },
        {
          label: "LIMIT",
          value: "LIMIT",
        },
      ],
      eventType: [
        {
          label: "Order-Fulfilled",
          value: "ORDER_FULFILLED",
        },
      ],
      unitOfMeasurementtype: [
        {
          label: "Occurrence",
          value: "OCCURRENCE",
        },
        {
          label: "Minute",
          value: "MINUTE",
        },
        {
          label: "Second",
          value: "SECOND",
        },
        {
          label: "GB",
          value: "GB",
        },
        {
          label: "MB",
          value: "MB",
        },
        {
          label: "Amount",
          value: "AMOUNT",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    orgAccessListOptions() {
      let data = Array.isArray(this.$store.getters["partner/GetPartnerList"])
        ? this.$store.getters["partner/GetPartnerList"]
        : [];
      let tenantList = [];
      if (data.length > 0) {
        data.map((obj) => {
          if (this.inputObject.orgAccessLevel.value === "LIMITED") {
            let arrayObj = {
              keys: obj._id,
              name: obj.authentication.userName,
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
    taxcodeoptions() {
      let data = this.$store.getters["taxcode/GetTaxcodeList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          label: d.taxCode,
          value: d._id,
        }));
      }
      return [];
    },
    accessrulesList() {
      let data = this.$store.getters["accessrule/accessRuleList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            label: d.name.toUpperCase(),
            value: d._id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    fetchingAllData() {
      this.inputObject.planName = this.details.planName;
      this.inputObject.scope = {
        label: this.details.scope,
        value: this.details.scope,
      };
      this.inputObject.isActive = this.details.isActive;
      this.inputObject.description = this.details.planDescription;
      let fiterOgroList = [];
      if (this.details.orgAccess.orgAccessLevel) {
        this.inputObject.orgAccessLevel = {
          label: this.details.orgAccess.orgAccessLevel.toUpperCase(),
          value: this.details.orgAccess.orgAccessLevel.toUpperCase(),
        };
      } else {
      }
      if (
        this.details.orgAccess.orgAccessList &&
        this.details.orgAccess.orgAccessLevel == "LIMITED"
      ) {
        this.details.orgAccess.orgAccessList.forEach((obj) => {
          let eachFilteredList = this.orgAccessListOptions.filter((element) => {
            return element._id == obj;
          });
          fiterOgroList.push(eachFilteredList);
        });
      }
      let modifiedOrgodata = [];
      fiterOgroList.forEach((obj) => {
        modifiedOrgodata.push(obj[0]);
      });
      this.inputObject.orgAccessList = modifiedOrgodata;
      this.inputObject.paymentType = {
        label: this.details.paymentType,
        value: this.details.paymentType,
      };
      let taxCodeFilter = Array.isArray(this.$store.getters["taxcode/GetTaxcodeList"])
        ? this.$store.getters["taxcode/GetTaxcodeList"].filter((obj) => {
            return obj._id == this.details.taxCode;
          })
        : [];
      if (taxCodeFilter.length > 0) {
        this.inputObject.taxCode = {
          label: taxCodeFilter[0].taxCode,
          value: taxCodeFilter[0]._id,
        };
      } else {
      }
      this.inputObject.chargeCode = this.details.chargeCode;
      this.inputObject.currency = this.details.pricing.currency;
      this.inputObject.cadencetype = {
        label: this.details.pricing.cadence,
        value: this.details.pricing.cadence,
      };
      this.inputObject.eventType = {
        label: this.details.pricing.eventType,
        value: this.details.pricing.eventType,
      };
      this.inputObject.uom = {
        label: this.details.pricing.uom,
        value: this.details.pricing.uom,
      };
      this.inputObject.baseQuantity = this.details.pricing.baseQuantity;
      this.inputObject.price = this.details.pricing.price;
      this.inputObject.autoRenewal = this.details.autoRenewal;
      let accessRuleFilter = Array.isArray(this.$store.getters["accessrule/accessRuleList"])
        ? this.$store.getters["accessrule/accessRuleList"].filter((obj) => {
            return obj._id == this.details.planAccess;
          })
        : [];
      if (accessRuleFilter.length > 0) {
        this.inputObject.planAccess = {
          label: accessRuleFilter[0].name.toUpperCase(),
          value: accessRuleFilter[0]._id,
        };
      } else {
      }
      this.inputObject.planType = {
        label: this.details.provisioning.planType,
        value: this.details.provisioning.planType,
      };
      this.inputObject.validity = this.details.provisioning.validity;
      this.inputObject.planlimit = this.details.provisioning.planLimit;
      let firstFeatureKey = true;
      this.inputObject.planFeatures = [];
      this.details.planFeatures.forEach((obj) => {
        if (firstFeatureKey) {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: false,
            text: "Add",
          });
          firstFeatureKey = false;
        } else {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: true,
            text: "Remove",
          });
        }
      });
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.inputObject.planFeatures.push({
          planFeatures: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.inputObject.planFeatures.splice(idx, 1);
    },
    async handleSubmit() {
      let x = [];
      this.inputObject.orgAccessList.forEach((obj) => {
        x.push(obj.keys);
      });
      let data = {};
      data = {
        // scope: this.inputObject.scope.value,
        planName: this.inputObject.planName,
        isActive: this.inputObject.isActive,
        planDescription: this.inputObject.description,
        planFeatures: this.inputObject.planFeatures.map((t) => t.planFeatures),
        // provisioning: {
        //   planLimit: this.inputObject.planlimit,
        //   planType: this.inputObject.planType.value,
        //   validity: this.inputObject.validity
        // },
        // planAccess: this.inputObject.planAccess.value,
        // paymentType: this.inputObject.paymentType.value,
        autoRenewal: this.inputObject.autoRenewal,
        // taxCode: this.inputObject.taxCode.value,
        // chargeCode: this.inputObject.chargeCode,
        // pricing: {
        //   cadence: this.inputObject.cadencetype.value,
        //   eventType: this.inputObject.eventType.value,
        //   price: this.inputObject.price,
        //   currency: this.inputObject.currency,
        //   baseQuantity: this.inputObject.baseQuantity,
        //   uom: this.inputObject.uom.value
        // },
        // orgAccess: {
        //   orgAccessLevel: this.inputObject.orgAccessLevel.value,
        //   orgAccessList: x
        // }
      };
      let payload = {
        id: this.details._id,
        data: data,
      };
      try {
        await this.$store.dispatch(
          "subscriptionplan/editSubscription",
          payload
        );
        this.$swal({
          title: "Success",
          text: "Subscriptionplan Updated successfully!!",
          type: "success",
        });
        this.$router.push({ name: "Subscription Plan" });
        await this.$store.dispatch(
          "subscriptionplan/subscriptionplanList",
          this.$store.getters["auth/getUserID"]
        );
      } catch (error) {
        this.$swal({
          title: "Opps!!!!!",
          text: "Can not Update Subscriptionplan!!",
          type: "error",
        });
      }
      this.$store.dispatch(
        "subscriptionplan/subscriptionList",
        this.$store.getters["auth/getUserID"]
      );
    },
  },
  async mounted() {
    this.loading = true;
    this.details = { ...this.$route.params.data };
    //this.getCatalogName();
    try {
      await this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
      await this.$store.dispatch("partner/officeList");
      await this.$store.dispatch("role/fetchRoles");
      await this.$store.dispatch(
        "taxcode/fetchTaxcodeListforTenant",
        this.$store.getters["auth/getUserID"]
      );
      await this.$store.dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      );

      this.fetchingAllData();
    } catch (error) {
      this.$toasted.error(error.message);
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
[btn-special="primary"]{
  width: 55px;
 height: 38px;
  padding: 0 12px;
  white-space: nowrap;
  color: white;
}
</style>
